<template>
  <div class="container technical-support">
    <div class="wrap">
      <div class="item">
        <div class="left">
          <img src="../../assets/images/support/img1.png" alt="" class="cover" />
        </div>
        <div class="right">
          <div class="text">
            <div class="title">SAAS结构服务平台</div>
            <div class="content">
              <p>
                定制：根据用户需求，实施量身定制，充分满足用户个性化需求。 <br />
                扩展：根据用户业务开展，即时扩展定制，实时更新。 <br />
                对接：根据用户业务模式，可与多家交易平台、多家承保机构完美对接， <br />方便实现用户的个性化业务需求。<br />
                部署：提供本地部署、云部署、混合部署多种部署模式。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="text">
            <div class="title">国密加密</div>
            <div class="content">
              <p>国家密码局认定的国产商用密码算法，满足电子认证服务系统等应用需求。</p>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="../../assets/images/support/img2.png" alt="" class="cover" />
        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../../assets/images/support/img3.png" alt="" class="cover" />
        </div>
        <div class="right">
          <div class="text">
            <div class="title">等保三级</div>
            <div class="content">
              <p>监管级别信息安全保护证明，非银行机构的最高认证！</p>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <div class="text">
            <div class="title">智能OCR识别</div>
            <div class="content">
              <p>
                对业务流转中客户提交资料，采用OCR智能识别技术，精准定位，<br />
                避免人工操作失误以及减少业务处理时长。
              </p>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="../../assets/images/support/img4.png" alt="" class="cover" />
        </div>
      </div>
      <div class="item">
        <div class="left">
          <img src="../../assets/images/support/img5.png" alt="" class="cover" />
        </div>
        <div class="right">
          <div class="text">
            <div class="title">企业大数据</div>
            <div class="content">
              <p>
                采集多维企业信息，搭建企业风控画像。<br />
                政府监管智能便捷，市场主体使用无忧。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TechnicalSupport',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0 80px;
  .item {
    width: 1000px;
    overflow: hidden;
    margin-bottom: 30px;
    float: left;
    &:nth-child(2n) {
      float: right;
    }
    .left,
    .right {
      float: left;
      .cover {
        width: 400px;
        height: 247px;
      }
      .text {
        .title {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 30px;
          color: #222222;
          margin: 40px 0 20px 0;
        }
        .content {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 32px;
          color: #333333;
        }
      }
    }
  }
}
</style>
